import { AutogenLayoutSettlementHistoryList } from "./autogen/AutogenLayoutSettlementHistoryList";
import { Label, TableRowDisplayEvent } from "@mcleod/components";

export class SettlementHistoryList extends AutogenLayoutSettlementHistoryList {
    async onLoad(): Promise<void> {
        this.mainDataSource.orderBy = [
            { field: "pay_date", sort: "desc" },
            { field: "payee_id", sort: "asc" },
            { field: "check_number", sort: "asc" },
            { field: "order_id", sort: "asc" }];
        this.tableSettlements.addRowDisplayListener((event: TableRowDisplayEvent) => {
            const tableRow = event.getTableRow();
            const labelOriginState = tableRow.findComponentById("labelOriginState") as Label;
            if (labelOriginState != null && !tableRow.data.isNull("origin_state")) {
                labelOriginState.text = ", " + tableRow.data.get("origin_state");
            }

            const labelDestinationState = tableRow.findComponentById("labelDestinationState") as Label;
            if (labelDestinationState != null && !tableRow.data.isNull("destination_state")) {
                labelDestinationState.text = ", " + tableRow.data.get("destination_state");
            }

        });
    }
}
